// frontend/modules/document-type/components/DocumentTypeFilters.tsx
import React from 'react';
import { Card, Input, Select, Space, Button, Row, Col } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { DocumentTypeFiltersData } from '../types/document-type.types';

const { Search } = Input;
const { Option } = Select;

interface DocumentTypeFiltersProps {
    filters: DocumentTypeFiltersData;
    onFiltersChange: (filters: Partial<DocumentTypeFiltersData>) => void;
    onClearFilters: () => void;
    loading?: boolean;
}

export const DocumentTypeFilters: React.FC<DocumentTypeFiltersProps> = ({
    filters,
    onFiltersChange,
    onClearFilters,
    loading = false
}) => {
    const handleSearchChange = (value: string) => {
        onFiltersChange({ search: value || undefined });
    };

    const handleActiveOnlyChange = (value: string) => {
        onFiltersChange({ 
            activeOnly: value === 'all' ? undefined : value === 'active' 
        });
    };

    const handleRequiredOnlyChange = (value: string) => {
        onFiltersChange({ 
            requiredOnly: value === 'all' ? undefined : value === 'required' 
        });
    };

    const hasActiveFilters = () => {
        return filters.search || filters.activeOnly !== undefined || filters.requiredOnly !== undefined;
    };

    return (
        <Card size="small" style={{ marginBottom: 16 }}>
            <Row gutter={16} align="middle">
                <Col xs={24} sm={12} md={8}>
                    <Search
                        placeholder="Search document types..."
                        value={filters.search || ''}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        onSearch={handleSearchChange}
                        enterButton={<SearchOutlined />}
                        allowClear
                        disabled={loading}
                    />
                </Col>
                
                <Col xs={12} sm={6} md={4}>
                    <Select
                        placeholder="Status"
                        value={
                            filters.activeOnly === undefined 
                                ? 'all' 
                                : filters.activeOnly 
                                    ? 'active' 
                                    : 'inactive'
                        }
                        onChange={handleActiveOnlyChange}
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        <Option value="all">All Status</Option>
                        <Option value="active">Active Only</Option>
                        <Option value="inactive">Inactive Only</Option>
                    </Select>
                </Col>
                
                <Col xs={12} sm={6} md={4}>
                    <Select
                        placeholder="Requirement"
                        value={
                            filters.requiredOnly === undefined 
                                ? 'all' 
                                : filters.requiredOnly 
                                    ? 'required' 
                                    : 'optional'
                        }
                        onChange={handleRequiredOnlyChange}
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        <Option value="all">All Types</Option>
                        <Option value="required">Required Only</Option>
                        <Option value="optional">Optional Only</Option>
                    </Select>
                </Col>
                
                <Col xs={24} sm={24} md={8}>
                    <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                        {hasActiveFilters() && (
                            <Button
                                type="default"
                                icon={<ClearOutlined />}
                                onClick={onClearFilters}
                                disabled={loading}
                                size="small"
                            >
                                Clear Filters
                            </Button>
                        )}
                    </Space>
                </Col>
            </Row>
        </Card>
    );
};
